import { CloseCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  ConfigProvider,
  Form,
  Input,
  Row,
  Space,
  Typography,
  Upload,
  message,
} from "antd";
import { React, useContext, useRef, useState, useMemo } from "react";
import config from "../../../config";
import file from "../../download/authorization-form.pdf";
import { ThemeContext } from "../../../context/themeContext";
import { useTranslation, Trans } from "react-i18next";

const { Title, Link } = Typography;
const TailFormItemLayout = {
  labelCol: {
    xl: {
      span: 24,
    },
  },
  wrapperCol: {
    xl: {
      span: 12,
    },
  },
};
const allowedTypes = [
  "application/pdf", // PDF
  "application/msword", // DOC
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
  "image/jpeg", // JPEG
  "image/png", // PNG
  "image/tiff", // TIFF
  "application/vnd.ms-excel", // XLS
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
  "text/plain", // TXT
];

const Document = ({ form, getChildData, setDefaultFile, defaultFile, setFileSizeError }) => {
  const { t, i18n } = useTranslation();
  const [fileFolder, setfileFolder] = useState("");
  const [Uploaderid, setUploaderid] = useState("");
  const [serviceurl, setserviceurl] = useState(config.apiurl);
  const [fileSize, setFileSize] = useState([]);

  const validationRules = useMemo(() => ({
    bulkRequestDocument: [
      { required: true, message: t("bulkRequest:please_upload_the_information") }
    ]
  }), [t]);
  const onChangeFileUploader = (name) => {
    setserviceurl(config.apiurl);
    setfileFolder(
      form.getFieldValue("nameorganization").toString() +
        form.getFieldValue("phone").toString() +
        "\\" +
        name
    );
    setUploaderid(name);
  };
  const hasShownError = useRef(false);
  // Helper function to calculate the total size of files
  const calculateTotalSize = (files) => {
    var size = files.size;
    size += fileSize.reduce((total, file) => total + file.size, 0);
    let fileList = fileSize;
    if (size / 1024 / 1024 <= 20) {
      fileList.push(files);
      // files.forEach(element => {
      //   fileList.push(element);
      // });
    }
    setFileSize(fileList);

    return size;
  };

  const props = {
    action: serviceurl + "SavePatientDetails/UploadFiles",
    data: { FolderName: fileFolder?.toString() },
    beforeUpload: (file, fileList) => {
      // Check if the file type is allowed
      const isAllowedType = allowedTypes.includes(file.type);
      if (!isAllowedType) {
        message.error(
          `${file.name} ${t("common:file_not_allowed")} ${t("common:allowed_file_types")}`
        );
        return Upload.LIST_IGNORE; // Prevent upload if type is not allowed
      }
      // Below code to check the size of files
      const totalSize = calculateTotalSize(file);
      const errors = [];
      // Check individual file size
      if (file.size / 1024 / 1024 >= 20) {
        message.error(t("common:each_file_must_be_smaller_than_10mb"));
        setFileSizeError(true);
        return Upload.LIST_IGNORE;
      }

      // Check total file size
      if (totalSize / 1024 / 1024 >= 20) {
        message.error(t("common:total_file_size_must_be_smaller_than_20mb"));
        setFileSizeError(true);
        return Upload.LIST_IGNORE;
      }
      // Show error message only if it hasn't been shown yet
      if (errors.length > 0 && !hasShownError.current) {
        message.error(errors.join(" "));
        // hasShownError.current = true;
        return Upload.LIST_IGNORE; // Prevent the file from being uploaded
      }

      // Reset error display state when validation passes
      if (errors.length === 0) {
        hasShownError.current = false;
      }

      return true; // Allow the file to be uploaded
    },

    // onChange(info) {
    //   let OnChangesfileArray = [];
    //   info.fileList.forEach((element) => {
    //     if (element.status === "done") {
    //       OnChangesfileArray = OnChangesfileArray.concat(element.response[0]);
    //     }
    //   });
    //   getChildData(OnChangesfileArray, Uploaderid);
    // },
    showUploadList: {
      extra: ({ size = 0 }) => (
        <span
          style={{
            color: "#cccccc",
          }}
        >
          ({(size / 1024 / 1024).toFixed(2)}MB)
        </span>
      ),
      showTitle: false,
      showRemoveIcon: true,
      removeIcon: <CloseCircleOutlined />,
    },
  };
  const callparent = (e, name) => {
    getChildData(e, name);
  };
  const DownloadLink = () => {
    const { theme } = useContext(ThemeContext);
    return (
      <Link
        type="link"
        className={`pb-1 ${theme}`}
        href={file}
        download={true}
        size="small"
        style={{ fontSize: 11 }}
      >
        <u>{t("bulkRequest:need_a_hipaa_authorization_form")}</u>
      </Link>
    );
  };
  const onChange = (name, { fileList }) => {
    let OnChangesfileArray = [];
    fileList.forEach((element) => {
      if (element.status === "done") {
        OnChangesfileArray = OnChangesfileArray.concat(element.response[0]);
      }
    });
    getChildData(OnChangesfileArray, Uploaderid);
    setDefaultFile({ ...defaultFile, [name]: fileList });
  };
  const resetSpecificField = (fieldName, file) => {
    form.setFieldsValue({ [fieldName]: "" }); // Reset field value
    let fileList = fileSize.filter((x) => x.uid !== file.uid);
    setFileSize(fileList);
  };
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            borderRadius: 20,
            fontWeight: "normal",
            fontSizeLG: 14,
          },
          Form: {
            itemMarginBottom: 30,
          },
          Upload: {
            fontSize: 12,
            fontSizeLG: 12,
          },
        },
      }}
    >
      <Card
      variant="borderless"
        size="0"
        styles={{ body: { padding: 0 } }}
        title={
          <Title
            className="font-semibold"
            style={{ marginBottom: "0" }}
            level={4}
          >
            {t("bulkRequest:documents")}
          </Title>
        }
      >
              <div className="px-1 md:px-6">
        <Form.Item
          {...TailFormItemLayout}
          className="font-medium item-mandatory label-description mb-6"
          label={
            <div className="flex flex-col text-left">
              <div>
                {t("bulkRequest:upload_hipaa_authorization_form")}
              </div>
              <DownloadLink />
            </div>
          }
          name="bulkRequestDocument"
          onChange={(e) => onChangeFileUploader("bulkRequestDocument")}
          rules={validationRules.bulkRequestDocument}
        >
          <Row gutter={[10, 0]} className="mb-0">
            <Col span={24}>
              <Upload
                accept={allowedTypes}
                {...props}
                defaultFileList={
                  defaultFile?.bulkRequestDocument?.length > 0 &&
                  defaultFile?.bulkRequestDocument
                }
                maxCount={1}
                multiple={false}
                onRemove={(e) => resetSpecificField("bulkRequestDocument", e)}
                onChange={(e) => onChange("bulkRequestDocument", e)}
              >
                <Button multiple={false} type="default">
                  {t("bulkRequest:upload")}
                </Button>
              </Upload>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item
          {...TailFormItemLayout}
          className="font-medium mb-6"
          name="additionalDocuments"
          label={t("bulkRequest:upload_any_additional_documents_optional")}
          onChange={(e) => onChangeFileUploader("additionalDocuments")}
        >
          <Row gutter={[10, 15]}>
            <Col span={24}>
              <Upload
                accept={allowedTypes}
                {...props}
                maxCount={5}
                multiple={true}
                defaultFileList={
                  defaultFile?.additionalDocuments?.length > 0 &&
                  defaultFile?.additionalDocuments
                }
                onRemove={(e) => resetSpecificField("additionalDocuments", e)}
                onChange={(e) => onChange("additionalDocuments", e)}
              >
                <Button type="default">{t("bulkRequest:upload")}</Button>
              </Upload>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item
          wrapperCol={{ lg: 12 }}
          name="nadditionaldocuments"
          className="font-medium"
          label={t("bulkRequest:any_additional_notes_optional")}
          onChange={(e) => callparent(e.target.value, "DocumentNotes")}
        >
          <Input maxLength={500} />
        </Form.Item>
        </div>
      </Card>
      <Space className="px-5">
      <Trans
      i18nKey="bulkRequest:bulk_upload_note"
      components={{
        i: <i className="notes-italic" style={{ fontSize: '.938rem' }} />,
        a: (
          <a
            href="mailto:requests@provider1st.com"
            className="font-bold underline"
          />
        ),
        span: <span className="font-bold underline" />
      }}
    />
      </Space>
    </ConfigProvider>
  );
};

export default Document;
